import script from "./residency-become-documents-upload.vue?vue&type=script&lang=ts&setup=true"
export * from "./residency-become-documents-upload.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__